import { gql } from '@apollo/client';

export default gql`
  mutation createUserBranch(
    $temp: String
    $users: Int
    $smss: Int
    $emails: Int
    $username: String
    $password: String
    $name: String
    $nameAr: String
    $tel1: String
    $note: String
  ) {
    createUserBranch(
      temp: $temp
      users: $users
      smss: $smss
      emails: $emails
      username: $username
      password: $password
      name: $name
      nameAr: $nameAr
      tel1: $tel1
      note: $note
    ) {
      ok
      message
      data
      error
    }
  }
`;
